module.exports = __webpack_public_path__ + "static/media/body_check.2a579aff.png";